export default [
  {
    path: '/',
    name: 'facility-search',
    component: () => import('@views/facility-search.vue'),
    alias: '/top',
  },
  {
    path: '/map',
    name: 'map',
    component: () => import('@views/map.vue'),
  },
  {
    path: '/redirect',
    name: 'redirect',
    component: () => import('@views/redirect.vue'),
  },
  {
    path: '/genre',
    name: 'genre',
    component: () => import('@views/genre.vue'),
  },
  {
    path: '/sub-genre',
    name: 'sub-genre',
    component: () => import('@views/sub-genre.vue'),
  },
  {
    path: '/facility-area',
    name: 'facility-area',
    component: () => import('@views/facility-area.vue'),
  },
	{
    path: '/facility-prefecture',
    name: 'facility-prefecture',
    component: () => import('@views/facility-prefecture.vue'),
  },
	{
    path: '/facility-municipality',
    name: 'facility-municipality',
    component: () => import('@views/facility-municipality.vue'),
  },
  {
    path: '/facility-detail/:id',
    name: 'facility-detail',
    component: () => import('@views/facility-detail.vue'),
  },
  {
    path: '/brand-facility/:id',
    name: 'brand-facility',
    component: () => import('@views/brand-facility.vue'),
  },
  {
    path: '/newend-facility',
    name: 'newend-facility',
    component: () => import('@views/newend-facility.vue'),
  },
  {
    path: '/searchTag-facility/:id/:genre?',
    name: 'searchTag-facility',
    component: () => import('@views/searchTag-facility.vue'),
  },
  {
    path: '/search-result',
    name: 'search-result',
    component: () => import('@views/search-result.vue'),
  },
  {
    path: '/coupon-list',
    name: 'coupon-list',
    component: () => import('@views/coupon-list.vue'),
  },
  {
    path: '/tag-coupon-list/:id',
    name: 'tag-coupon-list',
    component: () => import('@views/tag-coupon-list.vue'),
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404.vue').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  {
    path: '/system-error',
    name: 'system-error',
    component: require('@views/system-error.vue').default,
    props: true,
  },
  {
    path: '/facility-map',
    name: 'facility-map',
    component: () => import('@views/facility-map.vue'),
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]

// function lazyLoadView(AsyncView) {
//   const AsyncHandler = () => ({
//     component: AsyncView,
//     // A component to use while the component is loading.
//     loading: require('@views/_loading.vue').default,
//     // Delay before showing the loading component.
//     // Default: 200 (milliseconds).
//     delay: 200,
//     // A fallback component in case the timeout is exceeded
//     // when loading the component.
//     error: require('@views/_timeout.vue').default,
//     // Time before giving up trying to load the component.
//     // Default: Infinity (milliseconds).
//     timeout: 15000,
//   })

//   // AsyncView.catch((error) => {
//   //   console.log(error.name)
//   //   // window.location.reload()
//   // })

//   return Promise.resolve({
//     functional: true,
//     render(h, { data, children }) {
//       // Transparently pass any props or children
//       // to the view component.
//       return h(AsyncHandler, data, children)
//     },
//   })
// }
